import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
// import { UserProvider } from "./components/utils/UserContext";
import { Provider } from "react-redux";
import  store  from "./store/store";
// import '@fortawesome/fontawesome-free/css/all.min.css'; — Removed for performance (saves 100KB+ CSS and 400KB+ Fonts)


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<Provider store={store} >
	{/* <UserProvider> */}
		<Router>
			<App />
		</Router>
	{/* </UserProvider> */}
	</Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
